import 'bootstrap/js/dist/tooltip';
import $ from 'jquery';
import {CLASS_ACTIVE, TOGGLE_FAVOURITE} from './createButtonFavourite';

const SELECTOR_TOOLTIP_INNER = '.tooltip-inner';

/**
 *
 * @param {HTMLElement} element
 */
const isMounted = (element) => element.parentElement !== null;

/**
 *
 * @param {HTMLElement} element
 */
const getTitle = (element) => {
    if (element.classList.contains(CLASS_ACTIVE))
        return element.dataset.titleActive;
    else
        return element.dataset.titleInactive;
}

/**
 *
 * @param {HTMLButtonElement} button
 */
export default function createButtonFavouriteTooltip(button) {
    const $button = $(button);

    /** @type {HTMLElement} */
    let tip;

    const updateTooltip = () => {
        if (!isMounted(tip)) return;

        const tipInner = tip.querySelector(SELECTOR_TOOLTIP_INNER);

        if (!tipInner) return;

        tipInner.innerText = getTitle(button);
        $button.tooltip('update');
    }

    button.addEventListener(TOGGLE_FAVOURITE, updateTooltip);

    $button.tooltip({
        title: () => getTitle(button),
        placement: 'top',
        popperConfig: {
            /**
             *
             * @param {import('popper.js').Data} instance
             * @returns
             */
            onCreate: (instance) => tip = instance.instance.popper,
        },
    });
}
